"use strict";
exports.__esModule = true;
exports.format = void 0;
var utils_1 = require("./utils");
var TEMPLATE_REGEX = /\{([0-9a-zA-Z_.]+)\}/g;
function format(template, values) {
    if (values === void 0) { values = {}; }
    var flattenedValues = utils_1.flattenObject(values);
    if (!template) {
        return '';
    }
    return template.replace(TEMPLATE_REGEX, function (match, key, index) {
        if (template[index - 1] === '{' && template[index + match.length] === '}') {
            return key;
        }
        else {
            var cleanedKey = key.trim();
            var result = flattenedValues.hasOwnProperty(cleanedKey) ? flattenedValues[cleanedKey] : null;
            if (result === null || result === undefined) {
                return '';
            }
            else {
                return result;
            }
        }
    });
}
exports.format = format;
//# sourceMappingURL=format.js.map